/* eslint-disable @typescript-eslint/no-explicit-any */
import '@fontsource/inter/100.css';
import '@fontsource/inter/200.css';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import '@fontsource/inter/900.css';
import { GatsbyBrowser } from 'gatsby';
import { PageWrapper } from './src/PageWrapper';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element, props }) => (
  <PageWrapper page={element} data={props.data} pageContext={props.pageContext as any} />
);

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = () => {
  return [0, 0];
};

export const onClientEntry = () => {
  const { pagePath, rewrittenPath, ___loader } = window as any;

  if (process.env['NODE_ENV'] === 'development' || !___loader || !rewrittenPath) {
    return;
  }
  (window as any).pagePath = rewrittenPath;

  const originalLoadPageSync = ___loader.loadPageSync;
  const originalLoadPage = ___loader.loadPage;

  ___loader.loadPageSync = (path: string) => {
    const target = path === rewrittenPath ? pagePath : path;
    const pageResources = originalLoadPageSync(target);
    if (path === rewrittenPath && pageResources.page) {
      pageResources.page.path = rewrittenPath;
    }
    return pageResources;
  };

  ___loader.loadPage = async (path: string) => {
    const target = path === rewrittenPath ? pagePath : path;
    const pageResources = await originalLoadPage(target);
    if (path === rewrittenPath && pageResources.page) {
      pageResources.page.path = rewrittenPath;
    }
    return pageResources;
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ___loader.hovering = () => {};
};

export const disableCorePrefetching: GatsbyBrowser['disableCorePrefetching'] = () => true;
